import React, { useState, useEffect } from "react"
import Input from "../../Components/Input"
import Select from "../../Components/Select"
import image_back from "../../Images/Buttons/previous.png"
import image_save from "../../Images/Buttons/save.png"

const ClientEmail = ({jsonClientEmail, save, back, showMenu, width}) => {
  const [code, setCode] = useState("")
  const [clientCode, setClientCode] = useState("")
  const [email, setEmail] = useState("")
  const [contact, setContact] = useState("")
  const [standard, setStandard] = useState(0)

  useEffect(() => {      
    setCode(jsonClientEmail.ID)
    setClientCode(jsonClientEmail.CLIENT.ID)

    if ((jsonClientEmail.EMAIL !== undefined) && (jsonClientEmail.EMAIL != null)) setEmail(jsonClientEmail.EMAIL)
    if ((jsonClientEmail.CONTACT !== undefined) && (jsonClientEmail.CONTACT != null)) setContact(jsonClientEmail.CONTACT)

    setStandard(jsonClientEmail.STANDARD)

    document.getElementById("clientEmailNumber") && document.getElementById("clientEmailNumber").focus()

  }, [jsonClientEmail])

  const callSave = () => {
    let json = "{"
    if ((code !== undefined) && (code !== 0)) json += " \"ID\": "+ code + ","
    json += " \"CLIENT\": { \"ID\": " + clientCode + " }"
    if (email !== undefined) json += ", \"EMAIL\": \""+ email +"\""
    else json += ", \"EMAIL\": \"\""
    if (contact !== undefined) json += ", \"CONTACT\": \""+ contact +"\""
    else json += ", \"CONTACT\": \"\""
    json += ", \"STANDARD\": "+ standard +" }"

    save(json)
  }

  const setFieldSelected = () => {
  }
  
  return(
    <div style={{display: "flex", flexDirection: "column", flexGrow: 0}}>
      <div style={{display: "flex", flexDirection: "row", flexGrow: 0, flexWrap: "wrap", justifyContent: "center"}}>
        <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, marginTop: 5, marginLeft: 5,
          width: 147}} onClick={callSave}>
          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, paddingRight: 10,
            paddingBottom: 5, paddingLeft: 10}}>
            <img style={{height: 32, width: 32}} src={image_save} alt="Salvar"/>
          </div>
          <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
            <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Salvar</label>
          </div>
        </div>
        <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, marginTop: 5, marginLeft: 5,
          width: 147}} onClick={() => back()}>
          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, paddingRight: 10,
            paddingBottom: 5, paddingLeft: 10}}>
            <img style={{height: 32, width: 32}} src={image_back} alt="Retornar"/>
          </div>
          <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
            <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Retornar</label>
          </div>
        </div>
      </div>

      <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
        <div style={{backgroundColor: "rgb(0, 177, 171)", marginTop: 8, height: 10, width: "98%"}} />
      </div>

      <div style={(width < 450) ? {paddingLeft: 5, paddingRight: 5, marginTop: 5} : {paddingLeft: 20, paddingRight: 20, marginTop: 5}}>
        { code === undefined ? <b>Inclusão:</b> : <b>Alteração:</b>  }

        <div style={(showMenu) ?
            (width < 1130) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10}
            : {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 10}
          :
            {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}}>

          <div style={(showMenu) ?
              (width < 620) ? {display: "flex", flexDirection: "column", flexGrow: 1}
              : (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 1}
              : (width < 900) ? {display: "flex", flexDirection: "column", flexGrow: 1}
              : {display: "flex", flexDirection: "row", flexGrow: 1}
            :
              {display: "flex", flexDirection: "row", flexGrow: 0}}>

            <div style={(showMenu) ?
                (width < 780) ? {display: "flex", flexDirection: "row", flexGrow: 1, minWidth: 180}
                : {display: "flex", flexDirection: "row", flexGrow: 1, minWidth: 380}
              :
                (width < 900) ? {display: "flex", flexDirection: "row", flexGrow: 1, minWidth: 180}
                : {display: "flex", flexDirection: "row", flexGrow: 1, minWidth: 450}}>

              <Input
                type="text"
                name="clientEmailNumber"
                description="Email"
                value={email}
                maxLength={70}
                disabled={false}
                require={true}
                image={false}
                typeImage={0}
                typeInput={2}
                onSelect={setFieldSelected}
                onChange={(event) => setEmail(event.target.value)} />
            </div>
            <div style={(showMenu) ?
                (width < 620) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 10, minWidth: 180}
                : (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 10, minWidth: 120, maxWidth: 120}
                : (width < 900) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 10, minWidth: 180}
                : {display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 10, minWidth: 120, maxWidth: 120}
              : 
                (width < 450) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 10, minWidth: 180}
                : {display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 10, minWidth: 120, maxWidth: 120}}>

              <Select
                name="clientEmailStandard"
                description="Padrão"
                value={standard || 2}
                require={false}
                options={JSON.parse("{ \"RESULT\": [{\"ID\": 0, \"VALUE\": \"Selecione...\" }, {\"ID\": 1, \"VALUE\": \"Sim\" }"+
                  ", {\"ID\": 2, \"VALUE\": \"Não\" }] }")}
                image={false}
                typeImage={0}
                typeInput={2}
                onSelect={setFieldSelected}
                set={setStandard} />
            </div>
          </div>
          <div style={(showMenu) ?
              (width < 1130) ? {display: "flex", flexGrow: 1, marginTop: 10, minWidth: 180}
              : {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}
            :
              {display: "flex", flexGrow: 1, marginLeft: 10}}>

            <Input
              type="text"
              name="clientEmailContact"
              description="Contato"
              value={contact}
              maxLength={60}
              disabled={false}
              require={false}
              image={false}
              typeImage={0}
              typeInput={2}
              onSelect={setFieldSelected}
              onChange={(event) => setContact(event.target.value)} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClientEmail